import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import Text from "@/components/atoms/Text/Text";

interface SectionProps {
  number: string;
  title: string;
  children: React.ReactNode;
  badgeVariant?: 'default' | 'secondary';
  whiteNumbers?: boolean;
}

const Section: React.FC<SectionProps> = ({ number, title, children, badgeVariant = 'default', whiteNumbers = false }) => (
    <Card className="border-0 shadow-none">
      <CardHeader className="pb-3 px-4 sm:px-6">
        <CardTitle className="flex items-start sm:items-center gap-3 text-base sm:text-lg">
          <Badge 
            variant={badgeVariant} 
            className={`w-6 h-6 rounded-full flex items-center justify-center text-sm shrink-0 mt-0.5 sm:mt-0 ${
              whiteNumbers ? 'bg-gray-800 text-white hover:bg-gray-700' : ''
            }`}
          >
            {number}
          </Badge>
          <span className="leading-tight">{title}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 sm:px-6">
        <Text variant="body">{children}</Text>
      </CardContent>
    </Card>
  );

export default Section;